import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../../core/models/handle-error';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { AdminService } from '../../admin/admin.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { ToolsAndEquipmentManualsService } from '../tools-and-equipment-manuals.service';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { ToolReportSidebarComponent } from '../tool-report-sidebar/tool-report-sidebar.component';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../../shared/pipes/sort-by-filter.pipe';
import { FilterResultsPipe } from '../../../shared/pipes/filter-results.pipe';
import { LoadMoreItemsPipe } from '../../../shared/pipes/load-more-items.pipe';

@Component({
    selector: 'app-tool-report-content',
    templateUrl: './tool-report-content.component.html',
    styleUrls: ['./tool-report-content.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        ToolReportSidebarComponent,
        NgClass,
        NgStyle,
        FormsModule,
        NgFor,
        RouterLink,
        NgxPaginationModule,
        SearchFilterPipe,
        SortByFilterPipe,
        FilterResultsPipe,
        LoadMoreItemsPipe,
    ],
})
export class ToolReportContentComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscriptions: ISubscription[];

  public isShowAll = false;
  public isShowNew = true;
  public isShowHistory = false;
  APP_SETTINGS: any;
  public toolReportObject: any;
  public toolReports: any[];
  public docTitle: string;
  public sortBy = [];
  public newDocsCount: number;
  public serviceError = 'Loading data. Please wait...';
  private toolReportTitles: string[];
  public activeLink = true;
  errorMessage = '';

  // variables to update sort icons
  isDesc = false;
  column = '';
  direction: number;
  // display 6 series numbers by default
  public numOfItems = 6;

  // Object to toggle see notes
  expandReportNotes = {};
  expandReportModels = {};

  // For tablet and mobile versions
  public inputSIB;
  //public inputLocation;
  public inputSeries;
  public inputSortBy;
  public search4tools: string;
  public checkAutoships: boolean;
  public checkExternalMFR: boolean;

  private autoshipDownloadFlag: boolean = false;

  //public filter = { bulletinDisplayNumber: '', location: '', series: '', autoShip: false, externalMfrgToolWarranty: false };
  public filter = { bulletinDisplayNumber: '', series: '', autoShip: false, externalMfrgToolWarranty: false };
  public isToolReportsSaved: boolean = false;

  username: string;

  page: number = 1;
  isPaginateFlag = false;

  constructor(
    private utilityService: UtilityService,
    private toolsAndEquipManualService: ToolsAndEquipmentManualsService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthService,
    private adminService: AdminService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private route: ActivatedRoute
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    this.toolReports = [];
    this.subscriptions = [];
    this.toolReportTitles = [];
    this.APP_SETTINGS = APP_SETTINGS;
    this.search4tools = (APP_SETTINGS.currentPage == 'tool-report') ? this.toolsAndEquipManualService.getFilterData() : '';
    APP_SETTINGS.currentPage = 'tool-report';


    this.route.queryParams.subscribe(params => {
      let pageNum = parseInt(params['page']);
      this.page = Number.isNaN(pageNum) ? 1 : pageNum;
    });

    this.sortBy = [
      { key: 'orderPartNumber', value: 'Order Part Number' },
      { key: 'partNumber', value: 'Part Number' },
      { key: 'bulletinDisplayNumber', value: 'SIB' },
      { key: 'brand', value: 'Brand' }
    ];
    if (APP_SETTINGS.toolReport == 'all') { this.showAll(); }
    if (APP_SETTINGS.toolReport == 'new') { this.showNew(); }
    if (APP_SETTINGS.toolReport == 'history') { this.showHistory(); }
    this.toolReportObject = 'Complete Tool Report';
    this.subscriptions.push(this.utilityService.activeToolReportObject$.subscribe(value => {
      this.toolReportObject = value;
      if (this.isShowAll) {
        this.showAll();
      } else if (this.isShowNew) {
        this.showNew();
      } else if (this.isShowHistory) {
        this.showHistory();
      }
    }));
    this.subscriptions.push(this.utilityService.filterCriteria$.subscribe(value => {
      this.filter = value;
    }));
    // hide links in report side-bar if user clicked 'Autoship tool report' or 'Complete Tool report' to display the report content
    this.subscriptions.push(this.utilityService.passInfo$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.activeLink = data;
      }
    }));
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  showAll() {
    APP_SETTINGS.toolReport = 'all';
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.errorMessage = '';
    if (this.toolReports.length > 0) {
      this.activeLink = !this.activeLink;
    }
    this.utilityService.publishActiveTab('all');
    this.spinnerService.show('bmwSpinner');
    if (sessionStorage.getItem("savedToolReports")) {
      this.toolReports = JSON.parse(sessionStorage.getItem("savedToolReports"));
      this.spinnerService.hide('bmwSpinner');
    } else {
      this.subscriptions.push(this.toolsAndEquipManualService.getAllToolsReport().subscribe(data => {
        this.toolReports = data;
 
        if (this.toolReports.length === 0) {
          this.errorMessage = 'No Tool Reports';
        }
        if (this.toolReportObject === 'Autoship Tool Report') {
          this.toolReports = this.toolReports.filter(report => report['autoShip'] === true);
        }
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      },
        error => {
          this.errorMessage = 'No Tool Reports';
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }
  }
  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.toolReport = 'new';
    this.utilityService.publishActiveTab('new');
    this.activeLink = !this.activeLink;
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.toolsAndEquipManualService.getNewToolsReport().subscribe(data => {
      this.toolReportTitles = [];
      this.toolReports = data;
      this.changeDetector.detectChanges();
      if (this.toolReports.length === 0) {
        this.errorMessage = 'No New Tool Reports';
      }
      if (this.toolReportObject === 'Autoship Tool Report') {
        this.toolReports = this.toolReports.filter(report => report['autoShip'] === true);
      }
      //this.newDocsCount = this.toolReports.length;
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.errorMessage = 'No New Tool Reports';
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.errorMessage = '';
    APP_SETTINGS.toolReport = 'history';
    this.activeLink = !this.activeLink;
    this.utilityService.publishActiveTab('history');
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.toolsAndEquipManualService.getUserToolReportHistory(this.username).subscribe(data => {
      this.toolReportTitles = [];
      this.toolReports = data;
      this.changeDetector.detectChanges();
      if (this.toolReports.length === 0) {
        this.errorMessage = 'No History Found';
      }
      if (this.toolReportObject === 'Autoship Tool Report') {
        this.toolReports = this.toolReports.filter(report => report['autoShip'] === true);
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.errorMessage = 'No History Found';
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }

  saveToHistory(isSaved, docId, orderPartNumber) {
    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Tool Report', orderPartNumber, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Tool Report', orderPartNumber);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Tool Report', orderPartNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Tool Report', orderPartNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
    this.toolsAndEquipManualService.saveFilterData(this.search4tools);
    if (!isSaved) {
      //   this.subscriptions.push(this.toolsAndEquipManualService.addReportToUserHistory(this.username, docId).subscribe(value => {
      //     if (value) {
      //     }
      //   }));
    }
  }
  downloadExcel() {
    this.spinnerService.show('bmwSpinner');
    if (this.toolReportObject != null && this.toolReportObject === 'Autoship Tool Report') {
      this.autoshipDownloadFlag = true;
    } else {
      this.autoshipDownloadFlag = false;
    }

    this.adminService.downloadToolExcel(this.autoshipDownloadFlag).subscribe(data => {
      if (data) {
        const fileURL = URL.createObjectURL(data);
        this.spinnerService.hide('bmwSpinner');
        window.open(fileURL, '_blank');
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
      });
  }
  applyFilter() {
    this.filter = {
      bulletinDisplayNumber: this.inputSIB,
      //location: this.inputLocation,
      series: this.inputSeries,
      autoShip: this.checkAutoships,
      externalMfrgToolWarranty: this.checkExternalMFR
    };
  }
  clearFilter() {
    //this.inputSIB = this.inputLocation = this.inputSeries = '';
    this.inputSIB = this.inputSeries = '';
    this.checkAutoships = this.checkExternalMFR = false;
    //this.filter = { bulletinDisplayNumber: '', location: '', series: '', autoShip: false, externalMfrgToolWarranty: false };
    this.filter = { bulletinDisplayNumber: '', series: '', autoShip: false, externalMfrgToolWarranty: false };
  }

  pageNumChange(event) {
    this.page = event;
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  disablePagination() {
    this.isPaginateFlag = true;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
